import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { Button } from '@rsos/components/capstone/base';
import { useGetPreconfiguredMessagesQuery } from '@rsos/reduxDataStore/src/features/preconfiguredMessages';
import { organizationSelector } from '@rsos/reduxDataStore/src/features/selectors/organizationSelector';
import { AppState } from '../../types';
import AssignedMessages from './AssignedMessages';
import styles from './PreConfiguredMessages.module.css';
import PreconfiguredMessagesSearch from './PreconfiguredMessagesSearch';
import PreconfiguredMessagesTable from './PreconfiguredMessagesTable';
import ManageMessageModal from './modals/ManageMessageModal';

const PreconfiguredMessages = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  const orgName = useSelector((state: AppState) =>
    organizationSelector(state),
  )?.name;

  const {
    data: messages = [],
    isLoading,
    isFetching,
    isError,
  } = useGetPreconfiguredMessagesQuery(
    { org: orgName ?? '' },
    { skip: !orgName, refetchOnMountOrArgChange: true },
  );

  const isLoadingOrFetching = isLoading || isFetching;

  const handleSearch = useCallback((term: string) => {
    setSearchTerm(term.toLowerCase());
  }, []);

  const filteredMessages = messages.filter(message => {
    if (!searchTerm) return true;
    return (
      message.title.toLowerCase().includes(searchTerm) ||
      message.body.toLowerCase().includes(searchTerm)
    );
  });

  return (
    <div className={styles.container}>
      <AssignedMessages messages={messages} />
      <div className={styles.header}>
        <p className={styles.subtitle}>
          Create custom Preconfigured Messages for RapidSOS Unite's
          Text-From-911 service
        </p>
        <Button onClick={() => setIsCreateModalOpen(true)}>
          Create New Message
        </Button>
      </div>
      <div className={styles.content}>
        <PreconfiguredMessagesSearch onSearch={handleSearch} />
        <PreconfiguredMessagesTable
          messages={filteredMessages}
          isLoading={isLoadingOrFetching}
          isError={isError}
        />
      </div>
      <ManageMessageModal
        isOpened={isCreateModalOpen}
        onClose={() => setIsCreateModalOpen(false)}
      />
    </div>
  );
};

export default PreconfiguredMessages;
